import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocsMobiComponent } from './docs-mobi/docs-mobi.component';
import { DocsMenuComponent } from './docs-menu/docs-menu.component';
import { GetStartComponent } from './get-start/get-start.component';

const webTitle  = {
  title: 'Go Cashless with GoMobi Payment gateway in malaysia ',
  descrption: ' Mobi, enriches businesses of all sizes by providing a smart, secure, and innovative cashless payment gateway in Malaysia.',
  ogTitle: '',
};

const routes: Routes = [

  {path: 'DocsMobi', component: DocsMobiComponent,
    data: webTitle
  },
  {path: 'menu', component: DocsMenuComponent,
    data: webTitle
  },
  // {path:'', redirectTo: 'get-start', pathMatch:'full'},
  {path: 'Malaysia/', component: GetStartComponent,
    data: webTitle
  },
  {path: 'Indonesia/', component: GetStartComponent,
    data: webTitle
  },
  {path: '', component: GetStartComponent,
    data: webTitle
  },
  {path: 'Malaysia', loadChildren: () => import('./Documentation/malaysia/malaysia.module').then((c) => c.MalaysiaModule)},
  {path: 'Indonesia', loadChildren: () => import('./Documentation/indonesia/indonesia.module').then((c) => c.IndonesiaModule)},
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
